var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "page-heading"
  }, [_vm._v(_vm._s(_vm.title))]), _c('OptionList', {
    attrs: {
      "items": _vm.items,
      "perRow": _vm.perRow
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _vm._l(_vm.images, function (image, index) {
    return [_c('img', {
      staticClass: "w-100 mb-3",
      attrs: {
        "src": image.url
      },
      on: {
        "click": function click($event) {
          _vm.$refs["lightbox-".concat(index)][0].show([image.url]);
        }
      }
    }), _c('ImageLightBox', {
      ref: "lightbox-".concat(index),
      refInFor: true
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }